<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">{{ $t('add') }}</h2>
    <ProductForm @submit-requested="submitRequested"></ProductForm>
  </div>
</template>
 
<script>
import { mapActions } from 'vuex'
import ProductForm from './ProductForm.vue'

  export default {
  components: { ProductForm },
  methods: {
    ...mapActions('products', ['postProduct']),
    submitRequested (input) {
      this.postProduct(input);
    },
  }
}
</script> 
 
<style scoped>
thead > tr > th
{
  text-align: unset !important;
}
</style> 